import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import { useState, useRef } from 'react';
import '../useEventListener/c3560e46908f7d0b3c87fb45bf97bba8a41c7f11b9b9cc6ce5177ecd19c06ee3.cfe-internal.js';
import useEventListener from '../useEventListener/d298373edbbbe27e03edc667e68a196078d5abecbf27f9b61af0b7bc7dd7b6a0.cfe-internal.js';

/**
 * Tracks hovered state on element that `ref` is registered with
 * @returns `ref` to pass to element and `isFocused` state
 */
function useIsHovered() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var ref = useRef(null);
  useEventListener(ref, 'mouseenter', function () {
    return setIsHovered(true);
  });
  useEventListener(ref, 'mouseleave', function () {
    return setIsHovered(false);
  });
  return [ref, isHovered];
}

export { useIsHovered as default };
